'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _flowReady = undefined;

var flowReady = function flowReady() {
  return new Promise(function (resolve, reject) {
    try {
      // If this throws, then something went wrong in flow-initialize
      // because window.Flow.set should be available at this point

      if (_flowReady) {
        resolve(_flowReady);
      } else {
        window.Flow.set('on', 'ready', function () {
          _flowReady = { ready: true };

          resolve(_flowReady);
        });
      }
    } catch (error) {
      reject({ ready: false, error: true, message: error });
      throw new Error('Flow failed to initialize.');
    }
  });
};

var flowActive = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return flowReady();

          case 3:
            return _context.abrupt('return', !!window.Flow.getExperience());

          case 6:
            _context.prev = 6;
            _context.t0 = _context['catch'](0);
            throw new Error('Flow failed to activate.');

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 6]]);
  }));

  return function flowActive() {
    return _ref.apply(this, arguments);
  };
}();

var localize = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$force = _ref3.force,
        force = _ref3$force === undefined ? false : _ref3$force;

    var isActive;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return flowActive();

          case 3:
            isActive = _context2.sent;


            if (isActive || force) {
              window.Flow.variants.localize();
              window.Flow.text.localize();
              window.Flow.cart.localize();

              PubSub.publish(_Constants2.default.flowLocalized, {});
            }
            _context2.next = 10;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2['catch'](0);
            throw new Error('Flow failed to localize.');

          case 10:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[0, 7]]);
  }));

  return function localize() {
    return _ref2.apply(this, arguments);
  };
}();

var getCountry = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
    var country;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return flowReady();

          case 3:
            country = 'USA';

            // If Flow is present and there is an active experience, use that country

            if (window.Flow.getExperience && window.Flow.getExperience()) {
              country = window.Flow.getCountry();
            }

            return _context3.abrupt('return', country);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3['catch'](0);
            throw new Error('Flow failed to get country.');

          case 11:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[0, 8]]);
  }));

  return function getCountry() {
    return _ref4.apply(this, arguments);
  };
}();

var init = function init() {
  window.Flow.set('on', 'ready', function () {
    var country = window.Flow.getCountry();
    var active = !!window.Flow.getExperience();

    PubSub.publish(_Constants2.default.flowReady, { active: active, country: country });
  });
};

exports.default = {
  init: init,
  isReady: flowReady,
  isActive: flowActive,
  localize: localize,
  getCountry: getCountry
};